import React from "react";
import ChartistGraph from "react-chartist";
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";


import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import InputLabel from "@material-ui/core/InputLabel";

import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import RangeSlider from 'react-dual-rangeslider';
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import fontb from '../../B-NAZANIN.TTF';
import fontb2 from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
//import page from './lda.html'
//var page= require('./lda.html')
//var htmlDoc = {__html: page};
import {Redirect} from "react-router";
import Typography from "@material-ui/core/Typography";
// import Grid from '@material-ui/core/Grid';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';


// import charts from "../Charts/Charts"
import Charts from "../Charts/Charts";
import Users from "../users/users"
import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
} from "../Charts/Charts2";

// import Button from '@material-ui/core/Button';
// import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
// import Icon from '@material-ui/core/Icon';
import SaveIcon from '@material-ui/icons/Save';
import {useMediaQuery} from 'react-responsive'
// const useStyles2 = makeStyles((theme) => ({
//     button: {
//       margin: theme.spacing(1),
//     },
//   }));

import {Grid, Segment} from 'semantic-ui-react'


const useStyles = makeStyles(styles);
let theme2 = createMuiTheme();

// const classes2 = useStyles();
const style = {width: 400, margin: 50};
theme2.typography.h2 = {
    [theme2.breakpoints.up('md')]: {
        fontSize: 25,
    },
    [theme2.breakpoints.down('sm')]: {
        fontSize: 19,
    },
};

function log(value) {
    console.log(value); //eslint-disable-line
}

let fontConfig = {

    file: [
        {
            fontFamily: 'Bnazanin',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        },
        {
            fontFamily: 'Btitr',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb2,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        }


    ]
}

class TrainLda extends React.Component {
    constructor(props) {

        super(props);
        // if (props.location.state){
        this.state = {
            // checkedPos1: null,
            // checkedPos2:null,
            matches: window.matchMedia("(max-width: 830px)").matches,
            classes: makeStyles(styles),
            action: false,
            category: null,
            checked1: false,
            checked2: false,
            setChecked: false,
            min: 1380,
            max: 1399,
            value2: 1390,
            Subject: 'زبان',
            imageuri: null,
            response: null,
            ht: null,
            NTopic: 5,
            // NWord:10,
            ShowImage: null,
            NTitle:0,
            // token: props.location.state.token,
            // Email: props.location.state.email,
            UserName: "",
            token: "",
        };

        // }
        // else
        //     this.state = {
        //         data: '',
        //         token: 1,
        //         UserName: 1,
        //     };


        this.handleChange3 = this.handleChange3.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
    }

    onSliderChange = value => {
        log(value);
    };

    onMinChange = e => {
        this.setState({
            min: +e.target.value || 0,
        });
    };
    onValueChange = e => {
        this.setState({
            value2: +e.target.value || 0,
        });
    };
    handleChange = e => {
        if (e.target.value >= 0) {
            this.setState({
                NTopic: e.target.value,
            });
        }
        console.log(e.target.value)
    };
    handleChange1 = e => {
        // if(e.target.value >=0){
        this.setState({
            NTopic: +e.target.value || 0,
        });
        // }

    };
    handleChange2 = e => {
        // if(e.target.value >=0){
        this.setState({
            NTitle: +e.target.value || 0,
        });
        // }

    };
    onMaxChange = e => {
        this.setState({
            max: +e.target.value || 100,
        });
    };

    handleChange3(event) {
        // console.log(this.state.value);
        this.setState({Subject: event.target.value});

    }

    handleSubmit(event) {
        alert('Your favorite flavor is: ' + this.state.value);
        event.preventDefault();
    }

    // handleChange(event) {
    //     this.setState({ NTopic: event.target.value });
    //   }

    //   handleChange1(event) {
    //     this.setState({ NWord: event.target.value });
    //   }

    render() {
        // 
        // console.log(this.props.location.state)
        const {
            state: {domain, values, update, reversed},
        } = this;
        // if (this.state.matches){
        return (

            <div>
                <GridContainer>
                    <Button
                        className="button"
                        style={{
                            marginTop: "-5%",
                            marginRight: "95%",
                            borderRadius: "20px",
                            fontFamily: "Btitr",
                            fontSize: 16,
                            width: "2%",
                            height: "3%",
                            backgroundColor: "rgb(0,191,214)"
                        }}
                        onClick={() => {
                            this.setState({
                                action: true
                            })
                        }

                        }
                        // onClick={this.handleSubmit}
                    >
                        خروج
                    </Button>
                    {
                        this.state.action ? <div>{this.check22()}</div> : null
                    }
                    {/* <div style={{marginTop:"-5%",marginRight:"97%"}}>hello</div> */}

                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.state.classes.cardTitleWhite}
                                    style={{fontFamily: 'Bnazanin', fontSize: 29}}>آموزش مدل LDA</h4>
                                {/* <p className={this.state.classes.cardCategoryWhite}> */}
                                {/*New employees on 15th September, 2016*/}
                                {/* </p> */}
                            </CardHeader>
                            <CardBody>

                                {
                                    this.state.matches ?
                                        <div style={{flexDirection: "column", display: "flex",}}>
                                            <div style={{width: "40%"}}>
                                                <InputLabel style={{
                                                    width: "100%",
                                                    fontSize: 25,
                                                    fontFamily: 'Bnazanin',
                                                    color: "black"
                                                }} htmlFor="select">حوزه علمی:</InputLabel>
                                                <select style={{width: "auto", fontSize: 19, marginTop: "3%",fontFamily: 'Bnazanin',}}
                                                        value={this.state.Subject} onChange={this.handleChange3}>
                                                    <option value="اقتصاد"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>اقتصاد
                                                    </option>
                                                    <option value="ادبیات"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>ادبیات
                                                    </option>
                                                    <option value="تربیت بدنی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>تربیت بدنی
                                                    </option>
                                                    <option value="تاریخ"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>تاریخ
                                                    </option>
                                                    <option value="جغرافیا"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>جغرافیا
                                                    </option>
                                                    <option value="حقوق"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>حقوق
                                                    </option>
                                                    <option value="روانشناسی علوم تربیتی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>روان‌شناسی و علوم تربیتی
                                                    </option>
                                                    <option value="زبان"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>زبان‌شناسی
                                                    </option>
                                                    {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                                    {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                                    <option value="علوم اسلامی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اسلامی
                                                    </option>
                                                    <option value="علوم کتابداری"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم کتابداری
                                                    </option>
                                                    <option value="علوم اجتماعی ارتباطات"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اجتماعی و ارتباطات
                                                    </option>
                                                    <option value="علوم سیاسی روابط الملل"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم سیاسی و روابط بین‌الملل
                                                    </option>
                                                    <option value="فلسفه منطق"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>فلسفه و منطق
                                                    </option>
                                                    <option value="مدیریت و حسابداری"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مدیریت و حسابداری
                                                    </option>

                                                    <option value="مطالعات هنر"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات هنر
                                                    </option>


                                                    <option value="مطالعات زنان"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات زنان
                                                    </option>


                                                    {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                                </select>
                                            </div>
                                            <div style={{width: "40%"}}>
                                                <InputLabel style={{
                                                    width: "100%",
                                                    fontSize: 25,
                                                    fontFamily: 'Bnazanin',
                                                    color: "black"
                                                }} htmlFor="select">تعداد موضوع:</InputLabel>
                                                <select style={{
                                                    width: "auto",
                                                    fontSize: 19,
                                                    marginTop: "3%",
                                                    fontFamily: 'Bnazanin',
                                                }} value={this.state.NTopic} onChange={this.handleChange1}>
                                                    <option value={5} style={{fontFamily: 'Bnazanin', fontSize: 25}}>5
                                                    </option>
                                                    <option value={10}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>10
                                                    </option>
                                                    <option value={15}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>15
                                                    </option>
                                                    <option value={20}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>20
                                                    </option>
                                                    <option value={25}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>25
                                                    </option>
                                                    <option value={30}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>30
                                                    </option>
                                                    <option value={35}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>35
                                                    </option>
                                                    <option value={40}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>40
                                                    </option>
                                                    <option value={45}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>45
                                                    </option>
                                                    <option value={50}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>50
                                                    </option>
                                                    <option value={100}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>100
                                                    </option>
                                                </select>

                                            </div>
                                        </div>


                                        :
                                        <div>
                                        <div style={{flexDirection: "row", display: "flex"}}>
                                            <div style={{width: "40%"}}>
                                                <InputLabel style={{
                                                    width: "100%",
                                                    fontSize: 25,
                                                    fontFamily: 'Bnazanin',
                                                    color: "black"
                                                }} htmlFor="select">حوزه علمی:</InputLabel>
                                                <select style={{width: "auto", fontSize: 19, marginTop: "3%",fontFamily: 'Bnazanin',}}
                                                        value={this.state.Subject} onChange={this.handleChange3}>
                                                    <option value="اقتصاد"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>اقتصاد
                                                    </option>
                                                    <option value="ادبیات"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>ادبیات
                                                    </option>
                                                    <option value="تربیت بدنی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>تربیت بدنی
                                                    </option>
                                                    <option value="تاریخ"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>تاریخ
                                                    </option>
                                                    <option value="جغرافیا"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>جغرافیا
                                                    </option>
                                                    <option value="حقوق"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>حقوق
                                                    </option>
                                                    <option value="روانشناسی علوم تربیتی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>روان‌شناسی و علوم تربیتی
                                                    </option>
                                                    <option value="زبان"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>زبان‌شناسی
                                                    </option>
                                                    {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                                    {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                                    <option value="علوم اسلامی"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اسلامی
                                                    </option>
                                                    <option value="علوم کتابداری"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم کتابداری
                                                    </option>
                                                    <option value="علوم اجتماعی ارتباطات"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اجتماعی   و ارتباطات
                                                    </option>
                                                    <option value="علوم سیاسی روابط الملل"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم سیاسی و روابط بین‌الملل
                                                    </option>
                                                    <option value="فلسفه منطق"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>فلسفه و منطق
                                                    </option>
                                                    <option value="مدیریت و حسابداری"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مدیریت و  حسابداری
                                                    </option>

                                                    <option value="مطالعات هنر"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات هنر
                                                    </option>


                                                    <option value="مطالعات زنان"
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات زنان
                                                    </option>


                                                    {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                                </select>
                                            </div>
                                            <div style={{width: "40%"}}>
                                                <InputLabel style={{
                                                    width: "100%",
                                                    fontSize: 25,
                                                    fontFamily: 'Bnazanin',
                                                    color: "black"
                                                }} htmlFor="select">تعداد موضوع:</InputLabel>
                                                <select style={{
                                                    width: "auto",
                                                    fontSize: 19,
                                                    marginTop: "3%",
                                                    fontFamily: 'Bnazanin',
                                                }} value={this.state.NTopic} onChange={this.handleChange1}>
                                                    <option value={5} style={{fontFamily: 'Bnazanin', fontSize: 25}}>5
                                                    </option>
                                                    <option value={10}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>10
                                                    </option>
                                                    <option value={15}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>15
                                                    </option>
                                                    <option value={20}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>20
                                                    </option>
                                                    <option value={25}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>25
                                                    </option>
                                                    <option value={30}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>30
                                                    </option>
                                                    <option value={35}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>35
                                                    </option>
                                                    <option value={40}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>40
                                                    </option>
                                                    <option value={45}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>45
                                                    </option>
                                                    <option value={50}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>50
                                                    </option>
                                                    <option value={100}
                                                            style={{fontFamily: 'Bnazanin', fontSize: 25}}>100
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    <div style={{width: "40%",marginTop:10}}>
                                    <InputLabel style={{
                                    width: "100%",
                                    fontSize: 25,
                                    fontFamily: 'Bnazanin',
                                    color: "black"
                                }} htmlFor="select">ضریب اثرگذاری عنوان مقاله:</InputLabel>
                                    <select style={{
                                    width: "auto",
                                    fontSize: 19,
                                    marginTop: "3%",
                                    fontFamily: 'Bnazanin',
                                }} value={this.state.NTitle} onChange={this.handleChange2}>
                                    <option value={0} style={{fontFamily: 'Bnazanin', fontSize: 25}}>0
                                    </option>
                                    <option value={1}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>1
                                    </option>
                                    <option value={2}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>2
                                    </option>
                                    <option value={3}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>3
                                    </option>
                                    <option value={4}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>4
                                    </option>
                                    <option value={5}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>5
                                    </option>
                                    <option value={6}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>6
                                    </option>
                                    <option value={7}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>7
                                    </option>
                                    <option value={8}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>8
                                    </option>
                                    <option value={9}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>9
                                    </option>
                                    <option value={10}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>10
                                    </option>
				    <option value={15}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>15
                                    </option>
                                    <option value={20}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>20
                                    </option>
                                    <option value={25}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>25
                                    </option>
                                    <option value={30}
                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>30
                                    </option>

                                    </select>
                                    </div>
                                    </div>

                                }


                                <div
                                    style={{marginTop: "6%", width: "100%", display: 'flex', justifyContent: "center"}}>
                                    <Button
                                        className="button"
                                        style={{
                                            fontFamily: "Btitr",
                                            fontSize: 22,
                                            width: "10%",
                                            backgroundColor: "rgb(151,75,177)"
                                        }}
                                        onClick={() => this.sentLDAData()}

                                    >
                                        پردازش
                                    </Button>
                                </div>

                            </CardBody>
                        </Card>


                    </GridItem>

                </GridContainer>

            </div>
        );


        // }

    }

    sentLDAData() {
	//        fetch("http://conalysis.ihcs.ac.ir:8080/train_LDA", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/train_LDA", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: this.state.Subject,
                email: this.props.location.state.email,
                nword: 20,
                ntopic: this.state.NTopic,
                ntitle:this.state.NTitle,
                type: '1',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);


            })
            .catch((error) => {
                console.log(error);
            });

    }


    check22() {
        if (this.state.action) {
            //   console.log("entered");
            return (
                // <BrowserRouter>
                <Redirect
                    to={{
                        pathname: "/",
                        // state: {
                        //   token: this.state.token,
                        //   UserName: this.state.UserName,
                        // },
                    }}
                />
                // </BrowserRouter>
            );
        }
    }

}

export default ReactFontFace(TrainLda, fontConfig);
